const syncProjection = () => import("../views/copybook/syncProjection");

const classSyncProjection = () => import("../views/copybook/classSyncProjection.vue");
const classSelection = () => import("../views/copybook/classSelection");
const classRoster = () => import("../views/copybook/classRoster");
const classTest = () => import("../views/copybook/classTest");

const examPaperTest = () => import("../views/copybook/examPaperTest.vue");
const copyBook = () => import("../views/copybook/copybook")
const createWord = () => import("../views/copybook/createWord")
const doohickey = () => import("../views/doohickey/doohickey")
const videoProjection = () => import("../views/copybook/videoProjection");
export default [
  {
    path: "/syncProjection",
    name: "syncProjection",
    meta: {
      title: '同步投影',
      keepAlive: false
    },
    component: syncProjection
  },
  {
    path: "/classSyncProjection",
    name: "classSyncProjection",
    meta: {
      title: '同步投影',
      keepAlive: false
    },
    component: classSyncProjection
  },
  {
    path: "/classSelection",
    name: "classSelection",
    meta: {
      title: '选择班级',
      keepAlive: false
    },
    component: classSelection
  },
  {
    path: "/classRoster",
    name: "classRoster",
    meta: {
      title: '选择班级',
      keepAlive: false
    },
    component: classRoster
  },
  {
    path: "/classTest",
    name: "classTest",
    meta: {
      title: '测试',
      keepAlive: false
    },
    component: classTest
  },


  {
    path: '/copybook',
    name: "copybook",
    meta: {
      title: '我的字帖',
      keepAlive: false
    },
    component: copyBook
  },
  {
    path: '/createWord',
    name: 'createWord',
    meta: {
      title: '创建字帖',
      keepAlive: false
    },
    component: createWord
  },
  {
    path: '/doohickey',
    name: 'doohickey',
    meta: {
      title: '窍门',
      keepAlive: false
    },
    component: doohickey
  },
  {
    path: "/videoProjection",
    name: "videoProjection",
    meta: {
      title: '视频投影',
      keepAlive: false
    },
    component: videoProjection
  },
  {
    path: "/examPaperTest",
    name: "examPaperTest",
    meta: {
      title: '测评报告',
      keepAlive: false
    },
    component: examPaperTest
  },
]
